export const TEMPLATE_NAMES = {
    CONSENT: "consent_form",
    SOB: "speak_on_behalf",
    LPPCANCELLATION: "lpp_cancellation",
    AOB: "apply_on_behalf"
} as const;

// Agreement template row ID 23
// AGREEMENT is combination of templates
export const AGREEMENT_TEMPLATE_ROW_ID = 23;    

export const APPLICANT_TYPE = {
    PRIMARY: "primary",
    COAPP: "co-applicant",
} as const;

export const ENVELOPE_ROLES = {
    CLIENT: "Client",
    COSIGNER: "CoSigner",
    LMC: "LMC",
    AGENT: "Agent",
    COAPPLICANT: "Co-Applicant",
} as const;

export const ALLOWED_SEND = ['created'] as const;
export const ALLOWED_RESEND = ['sent','delivered','resent','autoresponded','remindersent'] as const;
export const ALLOWED_MANUAL_UPLOAD = ['completed'] as const;
export const ALLOWED_VOID = ['sent','delivered','resent'] as const;

export const ADDITIONAL_DELIVERY_OPTIONS = [
    { value: 'SMS', display: 'SMS' },
    { value: 'WhatsApp', display: 'WhatsApp' },
] as const;

export const FIXED_TEXT_OPTIONS = ['sms','whatsapp'] as const;
export const DELIVERY_TYPE = ['default','multi'] as const;
export const RED_STATUS = ['autoresponded','voided'] as const;

export class RecipientListSettings {
  public static readonly AVATAR_COLORS: Record<string, string> = {
    CO: '#FF9045',
    CL: '#e8642f',
    AG: '#491FAD',
    MA: '#874F52',
  };
  public static readonly DEFAULT_AVATAR_COLOR = '#8a8a96';

  // Roles whose delivery channel checkboxes (Email/SMS/WhatsApp) are view-only
  public static readonly READONLY_CHANNEL_ROLES: string[] = ['AG', 'MA'];

  // Roles whose email/mobile are edited elsewhere in the form (Primary / Co-Applicant
  // sections) and should live-update the matching recipient's contact info here.
  public static readonly CONTACT_SOURCE_FIELDS: Record<string, { email: string; mobile: string }> = {
    CL: { email: 'Email', mobile: 'Mobile' },
    CO: { email: 'CoAppEmail', mobile: 'CoAppMobile' },
  };

  // Roles whose first/middle/last name are edited elsewhere in the form (Primary /
  // Co-Applicant sections) and should live-update the matching recipient's displayed name.
  public static readonly NAME_SOURCE_FIELDS: Record<string, { first: string; middle: string; last: string }> = {
    CL: { first: 'FirstName', middle: 'MiddleName', last: 'LastName' },
    CO: { first: 'CoAppFirstName', middle: 'CoAppMiddleName', last: 'CoAppLastName' },
  };
}


// Maps the full province name (FullProvince, e.g. "Manitoba") to the 2-letter code
// AddressProvince/Province are stored as, so editing FullProvince keeps them in sync.
export const PROVINCE_NAME_TO_CODE: Record<string, string> = {
    'Ontario': 'ON',
    'Quebec': 'QC',
    'Nova Scotia': 'NS',
    'New Brunswick': 'NB',
    'Manitoba': 'MB',
    'British Columbia': 'BC',
    'Prince Edward Island': 'PE',
    'Saskatchewan': 'SK',
    'Alberta': 'AB',
    'Newfoundland and Labrador': 'NL',
    'Northwest Territories': 'NT',
    'Nunavut': 'NU',
    'Yukon': 'YT',
};

export const DOCUSIGN_ALLOWED_VOID = ['sent'] as const;
